import React from 'react';
import { CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <>
      {/* Banner fino de oferta */}
      <div className="w-full bg-[#c41e3a] py-1.5 px-4 overflow-hidden" data-id="element-111">
        <div className="animate-scroll-right" data-id="element-112">
          <p className="text-white text-xs md:text-sm font-black tracking-widest whitespace-nowrap uppercase" data-id="element-113">
            💈 Oferta por lanzamiento — 60% de descuento · Acceso inmediato ·
            100% online 💈 Oferta por lanzamiento — 60% de descuento · Acceso
            inmediato · 100% online
          </p>
        </div>
      </div>

      <section className="w-full bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] py-10 md:py-16 lg:py-20 px-4 relative" data-id="element-114">
        {/* Logo flotante */}
        <div className="fixed top-4 left-4 z-50" data-id="element-115">
          <img src="https://cdn.magicpatterns.com/uploads/nTBDp8jLQqs428HDhKddZJ/ChatGPT_Image_24_feb_2026,_12_38_15_a.m..png" alt="Barber Pro Academy Logo" className="w-12 h-12 md:w-16 md:h-16 drop-shadow-2xl" data-id="element-116" />
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-117">
          <div className="text-center mb-8 md:mb-12" data-id="element-118">
            {/* Pre-headline */}
            <p className="text-xs md:text-sm text-[#e53935] mb-4 font-black tracking-widest uppercase bg-[#e53935]/10 inline-block px-4 py-1.5 rounded-full border border-[#e53935]/20" data-id="element-119">
              FORMACIÓN PROFESIONAL EN BARBERÍA
            </p>

            {/* H1 */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight text-white mb-5 md:mb-6" data-id="element-120">
              Aprendé barbería y empezá a generar ingresos con este oficio.
            </h1>

            {/* Subtítulo */}
            <p className="text-base md:text-xl text-gray-300 leading-relaxed max-w-xl mx-auto mb-8 md:mb-10" data-id="element-121">
              Una formación online con clases en video paso a paso, técnica
              profesional y un manual completo para dominar la barbería desde
              cero.
            </p>

            {/* Bullets arriba del botón */}
            <div className="grid grid-cols-2 gap-3 max-w-lg mx-auto text-left mb-8 md:mb-10" data-id="element-122">
              {[{
              text: 'Clases en video',
              icon: '🎥'
            }, {
              text: 'Método profesional',
              icon: '💈'
            }, {
              text: 'Acceso inmediato',
              icon: '⚡'
            }, {
              text: 'Manual incluido',
              icon: '📘'
            }].map(bullet => <div key={bullet.text} className="flex items-center gap-2 text-gray-200 bg-[#222] p-3 rounded-lg border border-gray-700 shadow-sm" data-id="element-123">
                  <span className="text-lg flex-shrink-0" data-id="element-124">{bullet.icon}</span>
                  <span className="text-sm md:text-base font-semibold" data-id="element-125">
                    {bullet.text}
                  </span>
                </div>)}
            </div>

            {/* CTA principal — visible sin scroll */}
            <div className="flex flex-col items-center gap-3 mb-10 md:mb-12" data-id="element-126">
              <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-lg inline-block text-center shadow-[0_0_20px_rgba(229,57,53,0.3)]" aria-label="Acceder a la formación" data-id="element-127">
                👉 ACCEDER A LA FORMACIÓN
              </a>
            </div>

            {/* Video principal (Loop de Fade) movido arriba de los bullets */}
            <div className="flex justify-center mb-6 md:mb-8" data-id="element-128">
              <div className="relative w-64 md:w-80 lg:w-96 aspect-[4/5] rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(229,57,53,0.15)] border-2 border-[#e53935]/20" data-id="element-129">
                <video src="https://cdn.magicpatterns.com/uploads/7fxPLbNf5mBaahruzQnSNU/PinDown.io_@bonshair_1772370785.mp4#t=7" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-130" />
                {/* Overlay sutil para integrarlo mejor con el fondo oscuro */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent opacity-60 pointer-events-none" data-id="element-131"></div>
              </div>
            </div>

            {/* Mensaje emocional abajo del video */}
            <div className="flex justify-center" data-id="element-132">
              <p className="text-gray-300 text-sm md:text-base font-semibold bg-[#222] border border-gray-700 px-5 py-3 rounded-xl shadow-md max-w-md" data-id="element-133">
                Invertí en aprender un oficio que puede servirte toda la vida.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}